module.exports = __webpack_public_path__ + "img/cf.2ca1e2a8.svg";